import { useState, useEffect } from "react";

// Pasos del configurador v2. El resumen dejó de ser una sección propia:
// vive en la barra fija, así que el recorrido termina en la forma de pago.
const STEPS = ["1. Configuración", "2. Forma de pago"];

export default function Stepper({ activeStep = 1 }) {
    const [currentStep, setCurrentStep] = useState(activeStep);

    useEffect(() => {
        const handleScroll = () => {
            const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;

            // Progreso del scroll (0 a 1). Si la página no scrollea, seguimos en el paso 1
            const scrollPercent =
                scrollableHeight > 0
                    ? Math.min(Math.max(window.scrollY / scrollableHeight, 0), 1)
                    : 0;

            // Con dos pasos, la segunda mitad del scroll corresponde a la forma de pago
            const scrollBasedStep = scrollPercent > 0.5 ? 2 : 1;

            // Usar el mayor entre activeStep y scrollBasedStep
            setCurrentStep(Math.max(activeStep, scrollBasedStep));
        };

        window.addEventListener("scroll", handleScroll);

        // Ejecutar una vez al montar para establecer el estado inicial
        handleScroll();

        return () => window.removeEventListener("scroll", handleScroll);
    }, [activeStep]);

    const getStepClass = (step) => {
        if (step < currentStep) return "completed";
        if (step === currentStep) return "active";
        return "";
    };

    return (
        <ul className="stepper">
            {STEPS.map((label, index) => (
                <li key={label} className={getStepClass(index + 1)}>
                    {label}
                </li>
            ))}
        </ul>
    );
}
